import React from 'react';
import { Calendar, MapPin, Hash, Users, Eye, Search } from 'lucide-react';

const EventTable = ({ events, onViewDetails, formatDate, formatCurrency, totalEvents, currentPage, totalPages }) => {
  if (events.length === 0) {
    return (
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 overflow-hidden py-12 text-center">
        <div className="inline-flex p-4 bg-gray-100 rounded-full mb-3">
          <Search size={32} className="text-gray-400" />
        </div>
        <h3 className="text-lg font-semibold text-gray-500 mb-2">No events found</h3>
        <p className="text-gray-400">Try adjusting your search criteria</p>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-2xl shadow-lg border border-gray-200/50 overflow-hidden">
      <div className="px-6 py-5 border-b border-gray-100 bg-gradient-to-r from-gray-50/80 to-white">
        <div className="flex items-center justify-between">
          <div>
            <h3 className="text-lg font-semibold text-gray-900">Event Payment Reports</h3>
            <p className="text-sm text-gray-500 mt-1">
              {totalEvents} events with payment records • Click "View Payments" for detailed analysis
            </p>
          </div>
          <div className="text-sm">
            <span className="text-blue-700 font-bold">
              Page {currentPage} of {totalPages} • {totalEvents} total events
            </span>
          </div>
        </div>
      </div>

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gradient-to-b from-gray-50 to-gray-100/30">
            <tr>
              <th className="py-4 px-6 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b border-gray-200">Event Details</th>
              <th className="py-4 px-6 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b border-gray-200">Financial Summary</th>
              <th className="py-4 px-6 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b border-gray-200">Registration Stats</th>
              <th className="py-4 px-6 text-left text-xs font-semibold text-gray-700 uppercase tracking-wider border-b border-gray-200">Actions</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {events.map((event) => (
              <tr key={event.Event_Id} className="group hover:bg-blue-50/30 transition-colors duration-150">
                <td className="py-5 px-6">
                  <div>
                    <div className="font-semibold text-gray-900 text-lg mb-1 group-hover:text-blue-700 transition-colors">
                      {event.Event_Name}
                    </div>
                    <div className="flex flex-wrap gap-2 mb-2">
                      <span className="inline-flex items-center px-2.5 py-1 bg-blue-50 text-blue-700 rounded-lg text-sm">
                        <Calendar size={14} className="mr-1.5" />
                        {formatDate(event.Start_datetime)}
                      </span>
                      <span className="inline-flex items-center px-2.5 py-1 bg-gray-100 text-gray-700 rounded-lg text-sm">
                        <MapPin size={14} className="mr-1.5" />
                        {event.Event_Place}
                      </span>
                    </div>
                    <div className="text-sm text-gray-500">
                      <span className="flex items-center">
                        <Hash size={14} className="mr-2" />
                        <code className="bg-gray-100 px-2 py-1 rounded text-gray-700">ID: {event.Event_Id}</code>
                        <span className="mx-2">•</span>
                        <span className="text-gray-600">{event.Event_Sname}</span>
                      </span>
                    </div>
                  </div>
                </td>
                <td className="py-5 px-6">
                  <div className="space-y-3">
                    <div className="p-3 bg-gradient-to-r from-green-50 to-emerald-50/50 rounded-lg border border-green-100">
                      <div className="flex items-center justify-between">
                        <span className="text-gray-600 font-medium">Collected Amount</span>
                        <span className="font-bold text-green-700 text-lg">₹{event.Total_Revenue || 0}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="py-5 px-6">
                  <div className="space-y-3">
                    <div className="p-3 bg-gray-50 rounded-lg">
                      <div className="flex items-center text-gray-700 mb-1">
                        <Users size={16} className="mr-2 text-blue-500" />
                        <span className="font-medium">Registrations: {event.Total_Registration?.toLocaleString() || 0}</span>
                      </div>
                    </div>
                  </div>
                </td>
                <td className="py-5 px-6">
                  <div className="flex flex-col gap-2">
                    <button
                      onClick={() => onViewDetails(event)}
                      className="group inline-flex items-center px-4 py-2.5 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl font-medium hover:shadow-lg hover:-translate-y-0.5 transition-all duration-200 shadow-md"
                    >
                      <Eye size={16} className="mr-1.5 group-hover:scale-110 transition-transform" />
                      View Payments
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default EventTable;